export const TABLE_SIDE_ROWS = [
  { id: "name", label: "DA", hasSortLabel: true},
  { id: "tenured", label: "Tenured", hasSortLabel: true},
  { id: "badge", label: "Badge"},
  { id: "transporter_id", label: "Transporter ID"},
  { id: "availability_count", label: "# of Availability", hasSortLabel: true},
  { id: "actual_shifts", label: "# of Shifts", hasSortLabel: true},
  { id: "confirmed", label: "# of Confirmed", hasSortLabel: true},
  { id: "rejected", label: "# of Rejection", hasSortLabel: true},
  { id: "client_cancelled", label: "# of Client Cancelations", hasSortLabel: true},
  { id: "mycu_cancelled", label: "# of MYCU Cancelations", hasSortLabel: true},
]